export class AccountEvolution {
	labels: Array<string> = [];
	values: Array<number> = [];
	ticks: Array<number> = [];
	typeValue: Array<string> = [];
	evolutionHistoryEmpty: boolean;

	constructor() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/models/account-evolution.ts